import React from 'react';
import { smallerImage } from '../../utils';
import {useMediaQuery} from "react-responsive";
import GridHolder from './GridStyles';

const Grid = (props) => {

	// medium
	const isMd = useMediaQuery({query: '(min-width: 415px)'})
	// sm
	const isSm = useMediaQuery({query: '(max-width: 414px)'})
	const imgSz = isMd ? "md" : isSm ? "sm" : null;

	const renderGridItems = () => {
		return props.items.map((item, i) => {
			return (
				<a key={`grid-item-${i}`} href={item.url} className="grid-item" itemProp='itemListElement'>
				 	<img src={smallerImage(item.image,imgSz)} alt={item.altImageTxt} loading="lazy" itemProp='image' />
				</a>
			)
		});
	}

	return (
		<div itemScope itemType='https://schema.org/ItemList'>
		<GridHolder>
			{props.items && 
			renderGridItems()
			}
		</GridHolder>
		</div>
	)
}

export default Grid;